<p-toast [style]="{marginTop: '80px'}"></p-toast>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}


<div class="p-p-4">
  <form [formGroup]="form1">
    <p-fieldset styleClass="p-fluid" legend="Copy Rate Bucket" [toggleable]="false">
      <div class="p-fluid p-formgrid p-grid">

        <div class="p-field p-col-12">
          <span class="p-float-label">
            <input formControlName="name" id="name" type="text" pInputText>
            <label for="name">Enter New Rate Bucket Name</label>
            @for (validation of validationMessages.name; track validation) {
              <span>
                @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                  <small id="name2-help" class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="p-d-flex p-jc-end p-mt-4">
          @if (formErrorMessage) {
            <small class="p-invalid"><br>{{formErrorMessage}}<br></small>
          }
          <br>
            <button pButton type="button" label="Copy" (click)="onFormSubmit()"></button>
          </div>
        </div>
      </p-fieldset>
    </form>
  </div>